module.exports = __webpack_public_path__ + "static/media/la-picture-3.87b0ddcd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/Themes/LA/la-picture-3.jpg
// module id = 571
// module chunks = 0